export const selectRole = async ({ form, item }) => {
    form.setValues({
        "Role": item?.raw?.Role,
    });

    form.setConfig({
        "title": "Select Role",
        "type": "update",
        "location": `FlightTestCrew/${item.ID}`,
        "fields": [{
            "label": "Role",
            "name": "Role",
            "type": "dropdown",
            "dropdownData": [{
                "label": "Pilot",
                "id": "Pilot"
            }, {
                "label": "Lead Flight Test Engineer",
                "id": "Lead Flight Test Engineer"
            }, {
                "label": "Flight Test Engineer",
                "id": "Flight Test Engineer"
            }, {
                "label": "Flight Engineer (Third crew member)",
                "id": "Flight Engineer (Third crew member)"
            }, {
                "label": "Other (Observer , Test Equipment Operator)",
                "id": "Other (Observer , Test Equipment Operator)"
            }]
        }]
    });

    form.getDropdownData();
    form.toggle();
};

"Pilot",
    "Lead Flight Test Engineer",
    "Flight Test Engineer",
    "Flight Engineer (Third crew member)",
    "Other (Observer , Test Equipment Operator)"

export const updateContactDetails = ({ form, item }) => {
    form.setValues(item.raw.User || {});

    form.setConfig({
        "title": "Update Contact Details",
        "type": "update",
        "location": `FlightTestCrew/${item.ID}/User`,
        "fields": [{
            "label": "First Name",
            "name": "FirstName",
            "type": "text"
        }, {
            "label": "Last Name",
            "name": "LastName",
            "type": "text"
        }, {
            "label": "Phone Numebr",
            "name": "Phone",
            "type": "text"
        }, {
            "label": "Date of Birth",
            "name": "DateOfBirth",
            "type": "date"
        }]
    });

    form.toggle();
};

export const updateContactEmergencyDetails = ({ form, item }) => {
    form.setValues(item.EmergencyContact || {});

    form.setConfig({
        "title": "Update Emergency Contact Details",
        "type": "update",
        "location": `FlightTestCrew/${item.ID}/EmergencyContact`,
        "fields": [{
            "label": "First Name",
            "name": "FirstName",
            "type": "text"
        }, {
            "label": "Last Name",
            "name": "LastName",
            "type": "text"
        }, {
            "label": "Contact Number",
            "name": "Phone",
            "type": "text"
        }, {
            "label": "Contact Number 2",
            "name": "Phone2",
            "type": "text"
        }, {
            "label": "Relationship",
            "name": "Relation",
            "type": "text"
        }]
    });

    form.toggle();
};
